import { createEffect } from "effector";
import { handleAxiosError } from "../../../shared/lib/error/handleAxiosError";
import axios from "axios";


export const resetPasswordFx = createEffect(async (
    { email }: { email: string }
) => {
	try {
		const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/password/reset`, { email });
		return res.data;
	}
	catch (error: unknown) {
		handleAxiosError(error);
	}
})
